<template>
  <span class="svg-icon-grid-view">
    <svg class="icon-color-1" :style="`width:${width}px; height:${width}px; fill:none;`" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <!-- <path d="M14.1741 4.19684C231.036 2.21543 13.584 0 11.4232 0L3 0C1.34315 0 0 1.34315 0 3V22C0 23.6569 1.34315 25 3 25H11.2473C13.4527 25 14.9042 22.7004 13.9556 20.7095L10.9024 14.3021C10.5289 13.5183 10.5134 12.611 10.8598 11.8148L14.1741 4.19684Z" :fill="color"/> -->
      <path d="M14.1741 4.19684C15.0361 2.21543 13.584 0 11.4232 0L0 0V25H11.2473C13.4527 25 14.9042 22.7004 13.9556 20.7095L10.9024 14.3021C10.5289 13.5183 10.5134 12.611 10.8598 11.8148L14.1741 4.19684Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 15 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } }
  }
}
</script>
